/**
 * è·åæ ·å¼
 * @param  {Object} dom DOMèç¹
 * @param  {String} name æ ·å¼å
 * @param  {Any} defaultValue é»è®¤å¼
 * @return {String} å±æ§å¼
 */
export default function getStyle(dom, name, defaultValue) {
    var v;
    try {
        v = window.getComputedStyle ?
            window.getComputedStyle(dom, null)[name] :
            dom.style[name]; // ä¸è¬ä¸ä¼èµ°å°è¿ä¸ªé»è¾ï¼dom.style è·åçæ¯æ ç­¾ style å±æ§ï¼ä¹ä¸åç¡®
    }
    catch (e) {
        // do nothing
    }
    finally {
        v = v === undefined ? defaultValue : v;
    }
    return v;
}
//# sourceMappingURL=get-style.js.map